module.exports = __webpack_public_path__ + "img/qrcode.c396b2ab.jpeg";